import * as React from "react";

import { Table } from "../Table";
import { Pie } from "../Pie";
import { Series } from "../Series";
import { FilterList } from "../FilterList";
import { DayFilter, TitleFilter, getStore } from "../../store";
import { observer } from "mobx-react-lite";

export const App = observer(() => {
  const store = getStore();

  const daySelected = (day: number) => {
    store.addFilter(new DayFilter(day));
  };

  const titleSelected = (titleId: number, titleName: string) => {
    store.addFilter(new TitleFilter(titleId, titleName));
  };

  const onRemoveFilter = (index: number) => {
    store.removeFilter(index);
  };

  return (
    <div>
      <FilterList filters={store.filters} onRemoveFilter={onRemoveFilter} />
      <div className="row">
        <div className="col-md-7">
          <Series stats={store.currentStats} daySelected={daySelected} />
        </div>
        <div className="col-md-5">
          <Pie stats={store.currentStats} titleSelected={titleSelected} />
        </div>
      </div>
      <Table date={store.date} stats={store.currentStats} />
    </div>
  );
});
